import type React from 'react';
import { cn } from '@/utils/cn';

interface PlayerCropCardProps {
  playerId: string;
  imageUrl: string;
  isSelected: boolean;
  isDisabled?: boolean;
  onSelect: () => void;
}

export const PlayerCropCard: React.FC<PlayerCropCardProps> = ({
  playerId,
  imageUrl,
  isSelected,
  isDisabled = false,
  onSelect,
}) => {
  return (
    <button
      type="button"
      onClick={onSelect}
      disabled={isDisabled}
      className={cn(
        'h-full w-full rounded-xl focus:outline-none focus-visible:ring-2 focus-visible:ring-sky-500',
        isDisabled && 'pointer-events-none',
      )}
      aria-pressed={isSelected}
      aria-label={`Select ${playerId}`}
    >
      <div
        className={cn(
          'h-full cursor-pointer overflow-hidden rounded-xl border-2 transition-all duration-200',
          'bg-gradient-to-br from-slate-50 to-slate-100',
          isDisabled
            ? 'border-slate-200/30 opacity-40 grayscale'
            : isSelected
              ? 'scale-[1.03] border-slate-700 shadow-lg ring-2 ring-slate-700'
              : 'border-slate-200/50 opacity-70 hover:opacity-90',
        )}
      >
        <div className="aspect-[3/4] max-h-full w-full">
          <img
            src={imageUrl}
            alt={playerId}
            className="h-full w-full rounded-lg object-cover"
          />
        </div>
      </div>
    </button>
  );
};

export default PlayerCropCard;
